"use client";

import { decryptUrl } from "@/lib/helpers";
import dynamic from "next/dynamic";
import { useMemo } from "react";

const ViewKap = dynamic(
  () => import("@/app/(modules)/_components/view-kap"),
  { ssr: false }
);

export default function Page({ params }: { params: { key: string } }) {
  const decrypted = useMemo(() => {
    try {
      return decryptUrl(params.key);
    } catch (e) {
      return null;
    }
  }, [params.key]);

  if (!decrypted) {
    return <div className="p-4 text-red-500">Link tidak valid</div>;
  }
  const { docType, docId, revId  } = decrypted;

  return (
    <div className="p-4">
      {docType === 'program' && 
      <ViewKap
        programId={docId}
        revisionNum={revId}
        view="external"
      />}
    </div>
  );
}

